"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.featureAppVisibilityServiceDefinition = void 0;
// eslint-disable-next-line import/no-extraneous-dependencies
const integrator2fa_communication_1 = require("@volkswagen-onehub/integrator2fa-communication");
exports.featureAppVisibilityServiceDefinition = {
    id: 'feature-app-visibility-service',
    optionalDependencies: {
        featureServices: {
            's2:serialized-state-manager': '^1.0.0',
            's2:logger': '^1.0.0',
        },
    },
    create: (env) => {
        const serializedStateManager = env.featureServices['s2:serialized-state-manager'];
        const logger = (env.featureServices['s2:logger'] || console);
        const stateContainer = new integrator2fa_communication_1.ChannelStateContainer((s1, s2) => s1 === s2);
        if (typeof window !== undefined) {
            const stateAsString = serializedStateManager === null || serializedStateManager === void 0 ? void 0 : serializedStateManager.getSerializedState();
            if (stateAsString) {
                try {
                    const state = JSON.parse(stateAsString);
                    if (state) {
                        stateContainer.setSerializedState(state);
                    }
                }
                catch (e) {
                    logger.warn('failed to apply serialized state to featureAppVisibilityService', e);
                }
            }
        }
        serializedStateManager === null || serializedStateManager === void 0 ? void 0 : serializedStateManager.register(() => {
            return JSON.stringify(stateContainer.getSerializedState());
        });
        return {
            '1.0.0': (consumerId) => {
                const featureService = new integrator2fa_communication_1.ChannelService(consumerId, stateContainer);
                const unbind = () => featureService.cleanUp();
                return {
                    featureService,
                    unbind,
                };
            },
        };
    },
};
//# sourceMappingURL=index.js.map